import { defineMessage } from 'services/localization';

export const messages = {
    participant_rules_preview_amount_pattern: defineMessage('name_is_amount'),
    participant_rules_preview_total_amount_text: defineMessage('total_amount'),
    participant_rules_preview_net_amount_text: defineMessage('net_amount'),
    participant_rules_preview_amount_pattern_within: defineMessage(
        'over_or_equal_to_greatereq_and_under_less_currency'
    ),
    participant_rules_preview_amount_pattern_below: defineMessage('under_less_currency'),
    participant_rules_preview_amount_pattern_above: defineMessage('over_or_equal_to_greatereq_currency'),
    submitter_rules_preview_field_pattern: defineMessage('fieldname_matches_values'),
    submitter_rules_preview_not_field_pattern: defineMessage('fieldname_does_not_match_values'),
};
